'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {
//   ContainerDivs,
//   Link,
//   LinkIcon
// } from '../../components'

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _SelectDropdownPlan = require('./SelectDropdownPlan.css');

var _SelectDropdownPlan2 = _interopRequireDefault(_SelectDropdownPlan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// EXAMPLE USE IN FossilFuelBondsIn401ks
// <SelectDropdownPlan
//   plans={config.plansBondsSource}
//   value={this.state.planSelected}
//   onChange={this.onPlanSelect}
// />

var SelectDropdownPlan = (_dec = (0, _reactCssModules2.default)(_SelectDropdownPlan2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SelectDropdownPlan, _Component);

  function SelectDropdownPlan(props) {
    (0, _classCallCheck3.default)(this, SelectDropdownPlan);

    // if provided a specific list of plans.
    // else use all plans.
    var _this = (0, _possibleConstructorReturn3.default)(this, (SelectDropdownPlan.__proto__ || (0, _getPrototypeOf2.default)(SelectDropdownPlan)).call(this, props));

    var plans = _this.props.plans || _config2.default.plansSource;
    // default value, otherwise use value provided.
    var defaultValue = {
      name: 'Select an employer',
      label: 'Select  an employer'
    };
    var value = _this.props.value || defaultValue;
    _this.state = {
      defaultValue: defaultValue,
      value: value,
      planSelectOptions: (0, _keys2.default)(plans).map(function (key, i) {
        return {
          name: key,
          label: _config2.default.plansSource[key].short_name
        };
      })
    };
    return _this;
  }

  (0, _createClass3.default)(SelectDropdownPlan, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.value) {
        this.setState({ value: nextProps.value || this.state.defaultValue });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactSelect2.default, {
        name: 'plan-select',
        value: this.state.value,
        options: this.state.planSelectOptions,
        onChange: this.props.onChange
      });
    }
  }]);
  return SelectDropdownPlan;
}(_react.Component), _class2.propTypes = {
  plans: _react.PropTypes.object,
  value: _react.PropTypes.object,
  onChange: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = SelectDropdownPlan;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectDropdownPlan/SelectDropdownPlan.js
// module id = 1441
// module chunks = 0